


















import { Vue, Component } from 'vue-property-decorator'
import { $auth } from '@/services/Auth'

@Component
export default class AddUserForm extends Vue {

	email = ''
	pass = ''

	submit() {
		$auth.createUser(this.email, this.pass)
			.then(user => this.$emit('added', user))
			.catch(err => alert(err.message))
	}

}
